import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Button, Drawer } from 'antd'
import { MenuOutlined, CloseOutlined, ClockCircleOutlined } from '@ant-design/icons'
import RegistrationModal from './RegistrationModal'

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [registrationModalOpen, setRegistrationModalOpen] = useState(false)
  const location = useLocation()

  const navigation = [
    { name: 'Startseite', href: '/' },
    { name: 'Funktionen', href: '/features' },
    { name: 'Preise', href: '/pricing' },
    { name: 'Über uns', href: '/about' },
    { name: 'Kontakt', href: '/contact' },
  ]

  const toggleMenu = () => setIsOpen(!isOpen)

  const isActive = (path: string) => location.pathname === path

  return (
    <nav className="bg-white/95 backdrop-blur-md border-b border-gray-200 sticky top-0 z-50 shadow-sm">
      <div className="container-custom">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <img 
              src="/shiftedtime_logo.png" 
              alt="ShiftedTime" 
              className="h-8 w-auto group-hover:scale-105 transition-transform duration-200"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`relative px-3 py-2 text-sm font-medium transition-colors duration-200 ${
                  isActive(item.href)
                    ? 'text-blue-600'
                    : 'text-gray-700 hover:text-blue-600'
                }`}
              >
                {item.name}
                {isActive(item.href) && (
                  <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600" />
                )}
              </Link>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center space-x-4">
            <Button 
              type="text" 
              href="https://app.shiftedtime.de/login"
              className="text-gray-700 hover:text-blue-600"
            >
              Anmelden
            </Button>
            <Button 
              type="primary" 
              onClick={() => setRegistrationModalOpen(true)}
              icon={<ClockCircleOutlined />}
              style={{ backgroundColor: '#2563eb', borderColor: '#2563eb' }}
            >
              Kostenlos testen
            </Button>
          </div>

          {/* Mobile menu button */}
          <Button
            type="text"
            icon={isOpen ? <CloseOutlined /> : <MenuOutlined />}
            onClick={toggleMenu}
            className="md:hidden"
          />
        </div>
      </div>

      {/* Mobile Navigation Drawer */}
      <Drawer
        title={
          <div className="flex items-center">
            <img 
              src="/shiftedtime_logo.png" 
              alt="ShiftedTime" 
              className="h-6 w-auto"
            />
          </div>
        }
        placement="right"
        onClose={() => setIsOpen(false)}
        open={isOpen}
        className="md:hidden"
      >
        <div className="space-y-4">
          {navigation.map((item) => (
            <Link
              key={item.name}
              to={item.href}
              onClick={() => setIsOpen(false)}
              className={`block px-4 py-2 text-base font-medium rounded-lg transition-colors duration-200 ${
                isActive(item.href)
                  ? 'text-blue-600 bg-blue-50'
                  : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'
              }`}
            >
              {item.name}
            </Link>
          ))}
          <div className="pt-4 space-y-3 border-t border-gray-200">
            <Button 
              type="text" 
              href="https://app.shiftedtime.de/login"
              block
              className="text-left"
            >
              Anmelden
            </Button>
            <Button 
              type="primary" 
              onClick={() => {
                setRegistrationModalOpen(true)
                setIsOpen(false)
              }}
              icon={<ClockCircleOutlined />}
              block
              style={{ backgroundColor: '#2563eb', borderColor: '#2563eb' }}
            >
              Kostenlos testen
            </Button>
          </div>
        </div>
      </Drawer>

      <RegistrationModal 
        open={registrationModalOpen}
        onClose={() => setRegistrationModalOpen(false)}
      />
    </nav>
  )
}

export default Navigation 